export const INTERVIEW_ID_PARAM = 'interview_id';

export const STAGE_PARAM = 'stage';

export const VISIBLE_STAGES_PARAM = 'visible_stages';

export const JOBS_JOB_STATUS_PARAM = 'status';

export const STAGE_NAME_PARAM = 'stage_name';

export const SHOW_DATE_PROPOSE_PARAM = 'show_date_propose';

export const SHOW_COLLEAGUE_INTERVIEWS_PARAM = 'show_colleague_interviews';

export const RESCHEDULE_PARAM = 'reschedule';

export const HISTORY_PARAM = 'history';

export const SHOW_FEEDBACK_PARAM = 'feedback';
export const SHOW_COMPANY_CHAT = 'company_chat';

export const SHOW_OFFER_PARAM = 'offer';

export const FEEDBACK_ID_PARAM = 'feedback_id';

export const FEEDBACK_INTERVIEW_ID_PARAM = 'feedback_interview_id';

/** Set when navigating from an in-app notification click (suppresses hard /not-found redirect). */
export const FROM_NOTIFICATION_PARAM = 'from_notification';
